import { defineStore } from "pinia";
import { resourceHomepageList, getMemberRankByResourceLibId, getTotalResourceCount, getCenterInfo, getRoleList, getStudioList, getSubjectOption, getResourceRankByResourceLibId, homeView } from '@/api'
import router from '@/router'



const useHomeStore = defineStore('home', {
  state: () => ({
    //公共
    userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {}, //用户信息
    memberId: '', //用户ID
    showLogin: false, //是否显示登录弹窗
    isLogin: JSON.parse(sessionStorage.getItem('userInfo')) ? true : false,//是否已登录
    roleTypeId: '',  //角色类型Id
    roleId: '', //角色id
    studioList: JSON.parse(sessionStorage.getItem('studioList')) || [], //工作室列表
    allStage: [], //全部学段
    subjectList: [], //当前学段下全部学科
    academicStage: {}, //学段
    subject: {}, //学科
    stageAndsubject: '全部学科',//学科和学段
    showSubjectSelect: false, //是否显示学科学段下拉框
    showStudioList: false, //是否显示工作室下拉框
    showPersonSelect: false, //是否显示登录下拉框
    showScrollHeader: false,// 是否显示滚动头部
    breadListState: [], // 面包屑列表数据
    defaultTab: 0, //默认选中tab 首页 微课
    showUpload: false, //是否显示上传弹窗
    loginFromPersonSpace: false, //是否是点击个人空间后登录

    //home
    homepageList: [],  //列表数据
    current: 1,//列表页当前页数
    totalCount: '', //列表数据总数
    totalResource: {},  //   资源总量统计
    userList: [], //用户排行榜
    resourceHotList: [],//资源热度榜
    sort: '2',// 最新–2 浏览–5
    isLoadingMore:false,

  }),
  actions: {
    // 获取 资源总量统计
    async getTotalResourceCountM () {
      const res = await getTotalResourceCount()
      if (res.code == 0) {
        this.totalResource = res.data
      }
    },
    //获取列表
    async getHomepageList () {
      this.isLoadingMore= true
      const res = await resourceHomepageList({
        academicStageId: this.academicStage.id, //学段学科–学段id
        current: this.current, //当前页
        size: 20, //每页数
        sort: this.sort, //综合–1 最新–2 评价–3 收藏–4 浏览–5 下载–6
        sortWay: "DESC",  //排序方式 正序–ASC 倒序–DESC
        subjectId: this.subject.id,//–学科id
        type: null, //资源类型,传入null为全类型搜索 微课–minute_course 文档–document 研修–train

      })
      if (res.code == 0) {
        // console.log('homepageList', this.homepageList)
        this.homepageList.push(...res.data.objList)
        this.totalCount = res.data.pageBean.totalCount

        this.current++
        this.isLoadingMore= false
      }
    },
    //获取用户排行榜
    async getMemberRankByResourceLibIdM () {
      const res = await getMemberRankByResourceLibId()
      if (res.code == 0) {

        this.userList = res.data
      }
    },
    // 资源热度榜
    async getResourceRankByResourceLibIdM () {
      const res = await getResourceRankByResourceLibId()
      if (res.code == 0) {
        this.resourceHotList = res.data
      }
    },
    //退出后清除相关数据
    quitClearData () {
      sessionStorage.removeItem('userInfo')
      this.userInfo = {}
      this.isLogin = false

      // this.stageAndsubject = '全部学科'
      // this.academicStage = {}
      // this.subject = {}
    },
    //登录后获取用户信息 等相关处理    type为check则是校验登陆调用
    async getUserInfo (type) {

      const res1 = await getRoleList()
      if (res1.code == 0) {
        this.roleTypeId = res1.data[0].roleTypeId
        this.roleId = res1.data[0].roleId
        const res2 = await getCenterInfo({
          roleTypeId: res1.data[0].roleTypeId,
          roleId: res1.data[0].roleId
        })
        if (res2.success) {
          this.userInfo = res2.data
          //校验登陆不需要调用 登陆时需要用  如果切换账号则用最新的(在工作室登陆了另一个账号) 
          const isSwitchAccount = res2.data.userName != JSON.parse(sessionStorage.getItem('userInfo'))?.userName
          if (type !== 'check' || isSwitchAccount) {
            this.handleStageAndSubject(res2.data)
          }
          console.log('location',location)
          // 从工作室跳过来的时候 getHomepageList在home里调用的太早了  改为在这里调用
          if(location.hash.includes('#/home/index')){
            console.log('#/home/index 获取首页数据')
            this.current = 1
            this.homepageList = []
            await this.getHomepageList()
          }

          // 存取用户信息到session中
          sessionStorage.setItem('userInfo', JSON.stringify(this.userInfo))

          this.showLogin = false
          this.isLogin = true
          // 如果接口返回有学段学科数据 则弹窗不需要展示 
          if(res2.data.scStage){
            this.showSubjectSelect = false
          }
          // if( this.stageAndsubject.dictName !== '全部' ){
            // this.showSubjectSelect = false
          // }
          // password. = ''
          // userName. = ''

          //在未登录时，点击“个人空间”菜单后显示登录弹窗，登录成功后直接进入个人空间页面，其余四个支持未登录点击查看
          if (this.loginFromPersonSpace) {
            // console.log('router', router,)
            router.push({
              path: '/personSpace'
            })
            this.loginFromPersonSpace = false
            this.defaultTab = -1

          

          }
        }

        const resForStudio = await getStudioList({ roleId: this.roleId, roleTypeId: this.roleTypeId })
        if (resForStudio.code == 0) {
          this.studioList = resForStudio.data.list || []
          sessionStorage.setItem('studioList', JSON.stringify(this.studioList))

        }
      }
    },
    //处理学科学段信息
    async handleStageAndSubject (data) {
      this.academicStage.id = data.scStage
      this.subject.id = data.special
      if (!this.academicStage.id) {
        this.stageAndsubject = '全部学科'
        this.subjectList = [{
          dictName: '全部学科',
          id: null
        }]
        //显示学科学段让勾选
        this.showSubjectSelect = true
        return
      }

      this.academicStage = this.allStage.find(item => item.id == this.academicStage.id) || {}
      //根据学段信息获取学科信息
      const res = await getSubjectOption({ dictId: this.academicStage.id, dictLevel: 2 })
      if (res.code == 0) {
        this.subjectList = res.data
        this.subject = this.subjectList.find(item => item.id == this.subject.id)
        this.stageAndsubject = this.academicStage.dictName + ' | ' + this.subject.dictName

        // this.current = 1
        // this.homepageList = []


        // this.getHomepageList()
      }

    },
    // 首页访问量
    async homeViewM () {
      const res = await homeView()

    }

  },
  // persist:true,
  persist:  {
    paths: ['userInfo',"memberId", 'showLogin','isLogin', 'roleTypeId', 'roleId', 'studioList', 'allStage', 'subjectList', 'academicStage',
    'subject', 'stageAndsubject', 'showSubjectSelect','showStudioList','showPersonSelect', 'showScrollHeader', 'breadListState', 'defaultTab', 'showUpload',
    'loginFromPersonSpace',
  ]
  }

})

export default useHomeStore